// src/data/buddyTools.js
import bastianImage from '../assets/images/Bastian.png';
import invoiceBuddyImage from '../assets/images/invoice-buddy.svg';
import registrationBuddyImage from '../assets/images/registration-buddy.svg';
import libraryBuddyImage from '../assets/images/library-buddy.svg';

const buddyToolsData = [
  {
    id: 1,
    title: 'Bastian',
    path: 'bastian',
    description: 'A CSV tool for managing and analyzing your data.',
    image: bastianImage,
    brand: 'CSV'
  },
  {
    id: 2,
    title: 'InvoiceBuddy',
    path: 'invoicebuddy',
    description: 'An AI-powered tool for creating and managing invoices.',
    image: invoiceBuddyImage,
    brand: 'BuddyTools'
  },
  {
    id: 3,
    title: 'RegistrationBuddy',
    path: 'registrationbuddy',
    description: 'A tool for managing event and user registrations.',
    image: registrationBuddyImage,
    brand: 'BuddyTools'
  },
  {
    id: 4,
    title: 'LibraryBuddy',
    path: 'librarybuddy',
    description: 'A tool for managing and organizing your digital library.',
    image: libraryBuddyImage,
    brand: 'BuddyTools'
  }
];

export const getVisibleTools = () => {
  // For now, this function returns all tools.
  // In the future, this will be replaced with logic to fetch
  // and filter tools based on user/org subscriptions.
  return buddyToolsData;
};

export default buddyToolsData;
